<template>
  <el-form-item prop="wordLink" ref="formItem" verify :rules="variableArrRules" class="sky-url-link">
    <el-input v-model="url" :placeholder="placeholder"></el-input>
  </el-form-item>
</template>
<script type="text/babel">
import { Button, Input } from 'element-ui'

import { getFeiShuUrlAuth } from '@/api/setting'

export default {
  name: 'SkyFeiShuLink',
  inject: ['rootView', 'elForm'],
  components: {
    [Button.name]: Button,
    [Input.name]: Input
  },
  props: {
    value: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    enableType: {
      type: Array,
      default: function() {
        return ['Docs']
      }
    }
  },
  data() {
    return {
      url: null
    }
  },
  mounted() {},
  computed: {
    variableArrRules() {
      return [[{ validator: this.validatorBranch, trigger: ['blur', 'change'] }]]
    }
  },
  watch: {
    value(value) {
      this.url = value
    },
    url(value) {
      this.$emit('input', value)
    }
  },
  methods: {
    async validatorBranch(rule, value, callback) {
      let hasError = false
      if (this.url) {
        if (!this.validateUrlLink(this.url)) {
          hasError = true

          callback(new Error(this.$t('请输入链接')))
        }
        if (!this.validateFeiShuLink(this.url)) {
          hasError = true
          callback(new Error(this.$t('当前链接仅支持飞书的 文档 或者wiki 知识库节点')))
        }

        var authInfo = await this.validateFeiShuAuth(this.url)
        if (!authInfo.enableAuth) {
          hasError = true
          callback(new Error(this.$t('当前链接未对【东风服务运营平台授权】')))
        }
      }

      if (!hasError) {
        callback()
      }
    },
    async validateFeiShuAuth(link) {
      var authInfo = {
        type: null,
        enableAuth: false
      }
      await getFeiShuUrlAuth({ url: link }).then(res => {
        authInfo = res.data.content
      })
      return authInfo
    },
    validateUrlLink(link) {
      // 正则表达式，支持 http 和 https 协议
      const regex = /^(https?:\/\/)?([a-zA-Z0-9.-]+)(:[0-9]{1,5})?(\/.*)?$/
      return regex.test(link)
    },
    validateFeiShuLink(link) {
      const regex = /^(https:\/\/ruijie\.feishu\.cn\/(docx|wiki)(\/.*)?)$/
      return regex.test(link)
    }
  }
}
</script>
